import IStepTwoModel from './IStepTwoModel';

const StepTwoModelInitialState: IStepTwoModel = {
  vaziatKhesaratHavadesBNG: null,
  vaziatKhesaratSalesBNG: null,
};

export default StepTwoModelInitialState;
